import { useMemo } from "react";
import { DistinctValue } from "../../../types";
import { CATEGORY_CONFIGS } from "../../../config/categories-config";

/**
 * Hook for calculating category counts and enriched category data
 */
export default function useCategoryCalculations(
  distinctValues: DistinctValue[],
) {
  const getCategoryCount = (categoryId: number) => {
    return distinctValues.filter((val) => val?.categoryId === categoryId)
      .length;
  };

  const categories = useMemo(
    () =>
      CATEGORY_CONFIGS.map((config) => ({
        ...config,
        count: getCategoryCount(config.categoryId),
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [distinctValues],
  );

  return { categories, getCategoryCount };
}
